<template>
    <div class="manual">
        <!-- 15科普手册 -->

        <div class="manual-details">
            <div class="manual-details-left">
                <van-image :src="dataSource.cover_img" />
            </div>
            <div class="manual-details-right">
                <span class="title" v-html="dataSource.title"></span>
                <div class="content-text">
                    {{ dataSource.intro }}
                </div>
                <div class="manual-details-right-footer">
                    <div class="apply" @click="onOpenOverlay(dataSource)">
                        <van-image src="/static/bytx/anticancer/apply.svg" />
                        申请手册
                    </div>
                    <van-button
                        round
                        plain
                        class="read-btn"
                        type="primary"
                        color="#03CBBF"
                        size="mini"
                        @click="goDetails(dataSource)"
                        >在线阅读
                    </van-button>
                </div>
            </div>
        </div>

        <AddAssistant ref="RefAddAssistant"></AddAssistant>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import { AddAssistant } from '@/components/overlay'

export default {
    components: {
        AddAssistant
    },
    name: 'Manual',
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        isContent: {
            type: Boolean,
            default: true
        },
        contentType: {
          type: Number,
          default: 0
        },
        searchText: {
          type: String,
          default: ''
        }
    },
    computed: {
        dataSource() {
            return this.isContent ? this.dataItem.content : this.dataItem
        }
    },
    methods: {
        go_manual_detail(row) {
          Interface.getData('post', `/encyclopedia-phase/api/encyclopedia_manual/${row}/applyCount`)
        },
        onOpenOverlay(row) {
            this.go_manual_detail(row.id)
            this.$refs.RefAddAssistant.overlayShow = true
            Interface.mFootPrint(row.id,103,0,3,0,0,0,row.title)
        },
        // 获得详情
        goDetails(row) {
            const isMini = this.dataSource && this.dataSource.is_mini
            if (isMini == 1) {
              this.$toast('当前手册仅支持申请手册和在小程序中阅读')
              return
            }
            // 增加点击量
            this.$router.push({ name: 'manual-details', params: { id: row.id } })
            Interface.getData('get', `/course-phase/api/recommend_v2/${row.id}/view`)
            // Interface.footPrint1(15,row.id)
            if (this.contentType === 3) {
              Interface.mFootPrint(row.id,15,this.contentType,3,0,0,0,row.title, this.searchText)
            } else {
              Interface.mFootPrint(row.id,67,this.contentType,1,0,0,0,row.title, this.searchText)
            }

        }
    }
}
</script>

<style lang="scss" scoped>
.manual-details {
    display: flex;

    padding: 10px 12px;
    background-color: #ffffff;
    margin: 10px 10px;
    border-radius: 10px;

    &-left {
        position: relative;
        .van-image {
            height: 120px;
            width: 90px;
            >>> .van-image__img,
            img {
                border-radius: 6px;
            }
        }

        .describe {
            position: absolute;
            top: 42px;
            left: 26px;
            color: #fff;
            font-size: 12px;
            width: 40px;
            text-align: center;
        }
    }

    &-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-left: 10px;
        .title {
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #222222;
            letter-spacing: 0;
            line-height: 24px;
        }

        .content-text {
            flex: 1;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #777777;
            letter-spacing: 0;
            line-height: 20px;
        }
        &-footer {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .apply {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #0cc4b9;
                text-align: center;

                .van-icon {
                    font-size: 15px;

                    margin-right: 3px;
                }
            }

            .read-btn {
                .van-button__text {
                    font-size: 10px;
                    height: 26px;
                    line-height: 26px;
                    padding: 5px 20px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/manual.vue